export const roles = ["Buyer", "Seller", "Agent", "Transaction Coordinator"]

export const canAddContractRoles = ["Agent", "Transaction Coordinator"]

export const status = ["Not Started", "In-progress", "Completed", "Not Required"]

export const subscriptionGracePeriodInDays = 60